import React, { useContext } from 'react';
import AppContext from 'context/Context';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faLayerGroup,
  faClock,
  faCheckCircle,
  faExclamationCircle,
  faCodeBranch
} from '@fortawesome/free-solid-svg-icons';

const ReportKpiCards = ({ counts = {}, activeStatus = 'todos', onSelectStatus }) => {
  const { config: { isDark } = {} } = useContext(AppContext);

  const cardsData = [
    {
      id: 'todos',
      label: 'TODOS',
      count: counts.todos ?? 0,
      icon: faLayerGroup,
      color: isDark ? '#38bdf8' : '#0284c7',
      bgLight: '#e0f2fe',
      bgDark: 'rgba(56, 189, 248, 0.15)',
      activeBorder: isDark ? '#38bdf8' : '#0284c7'
    },
    {
      id: '1',
      label: 'PENDIENTES',
      count: counts.pendientes ?? 0,
      icon: faClock,
      color: '#d97706',
      bgLight: '#fef3c7',
      bgDark: 'rgba(245, 158, 11, 0.15)',
      activeBorder: '#f59e0b'
    },
    {
      id: '3',
      label: 'EN PROGRESO',
      count: counts.enProgreso ?? 0,
      icon: faExclamationCircle,
      color: '#2563eb',
      bgLight: '#dbeafe',
      bgDark: 'rgba(59, 130, 246, 0.15)',
      activeBorder: '#3b82f6'
    },
    {
      id: '2',
      label: 'RESUELTOS',
      count: counts.cerrados ?? 0,
      icon: faCheckCircle,
      color: '#059669',
      bgLight: '#d1fae5',
      bgDark: 'rgba(16, 185, 129, 0.15)',
      activeBorder: '#10b981'
    },
    {
      id: 'combinados',
      label: 'COMBINADOS',
      count: counts.combinados ?? 0,
      icon: faCodeBranch,
      color: isDark ? '#c084fc' : '#7c3aed',
      bgLight: '#f3e8ff',
      bgDark: 'rgba(168, 85, 247, 0.15)',
      activeBorder: '#8b5cf6'
    }
  ];

  return (
    <div className="row g-2 g-sm-3 mb-3 mb-sm-4">
      {cardsData.map(card => {
        const isActive = activeStatus === card.id;
        const isTodos = card.id === 'todos';

        return (
          <div
            key={card.id}
            className={`${isTodos ? 'col-12' : 'col-6'} col-sm-6 col-md-4 col-xl`}
          >
            <div
              className="p-2 p-sm-3 rounded-3 border d-flex align-items-center justify-content-between h-100 transition-base"
              style={{
                backgroundColor: isDark ? '#121e2d' : '#ffffff',
                borderColor: isActive ? card.activeBorder : (isDark ? '#233142' : '#e2e8f0'),
                boxShadow: isActive ? `0 0 0 1px ${card.activeBorder}` : 'none',
                cursor: 'pointer'
              }}
              onClick={() => onSelectStatus(card.id)}
              title={`Filtrar por ${card.label.toLowerCase()}`}
            >
              <div className="me-1 overflow-hidden">
                <span
                  className="text-muted d-block text-truncate mb-1"
                  style={{ fontSize: '0.68rem', fontWeight: 600, letterSpacing: '0.02em' }}
                >
                  {card.label}
                </span>
                <h3
                  className="fw-bold mb-0 fs-4 fs-sm-3"
                  style={{ color: card.color, lineHeight: 1.1 }}
                >
                  {card.count}
                </h3>
              </div>
              <div
                className="rounded-3 d-flex align-items-center justify-content-center flex-shrink-0"
                style={{
                  width: '36px',
                  height: '36px',
                  backgroundColor: isDark ? card.bgDark : card.bgLight,
                  color: card.color,
                  fontSize: '0.9rem'
                }}
              >
                <FontAwesomeIcon icon={card.icon} />
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default ReportKpiCards;
